import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient } from 'common/services';

type DownloadFileRouteParams = {
  url: string;
};

export const getFile = async ({ routeParams: { url } }: RouteParamsRequest<DownloadFileRouteParams>) =>
  apiClient.get<Blob, ApiClientResponse<Blob>>(url, {
    responseType: 'blob',
    skipAuth: true,
  });
